import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { jsPDF } from 'jspdf'
import { NgxSpinnerService } from 'ngx-spinner'
import { AuthenticationService } from 'src/app/_services'
import { environment } from 'src/environments/environment'
import domtoimage from 'dom-to-image'
import * as XLSX from 'xlsx'
import { ResponseItemsConf } from 'src/app/_models'
@Component({
  selector: 'app-confirm-container-items',
  templateUrl: './confirm-container-items.component.html',
  styleUrls: ['./confirm-container-items.component.css']
})
export class ConfirmContainerItemsComponent implements OnInit {
  arrayDatosExport = []

  ocultarT = true
  viewTable = false
  totalTable = 0
  arrayIte:ResponseItemsConf[];
  constructor (
    public spinner: NgxSpinnerService,
    private _httpClient: HttpClient,
    private authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<ConfirmContainerItemsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.arrayIte = []
    this.arrayDatosExport = []
    this.onChangeItemTableNew()
  }

  onNoClick (): void {
    this.dialogRef.close()
  }

  ngOnInit (): void {
    console.log(this.data)
  }

  OnConfirmItems () {
    console.log(this.arrayIte)
    this.viewTable = false
    this.spinner.show()

    try {
      for (let index = 0; index < this.arrayIte.length; index++) {
        const element = this.arrayIte[index]
        this.onConfirmNewContainerItems(element)
      }
    } catch (error) {}

    setTimeout(() => {
      this.spinner.hide()
      this.onChangeItemTableNew()
      this.viewTable = true
    }, 1200)
  }
  onUpdateItemsContainer (dat: any) {
    try {
      var js = {
        containerId: Number(this.data.container.Id),
        locationId: 0,
        itemNumber: String(dat.ItemNumber),
        quantity: Number(dat.Quantity),
        receiveQuantity: Number(dat.receiveQuantity),
        palletQuantity: Number(dat.palletQuantity),
        weight: Number(dat.weightTotal),
        active: 2
      }

      this._httpClient
        .post<any>(
          `${environment.apiUrl}/Containers/ContainersItemsUpdate?ID=${Number(
            dat.receiveItemsID
          )}`,
          js,
          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization:
                'Bearer ' + this.authenticationService.currentUserValue.token
            })
          }
        )
        .subscribe((response: any) => {})
    } catch (error) {}
  }
  OnviewTable () {
    if (this.viewTable) {
      this.viewTable = false
    } else {
      this.onChangeItemTableNew()
    }
  }


  onChangeItemTableNew () {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Containers/containerreceiveitemsSelectConfirmNew?ContainerID=${Number(
          this.data.container.Id
        )}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: ResponseItemsConf[]) => {
        this.arrayIte = response
        try {
          this.totalTable = 0
          for (let index = 0; index < this.arrayIte.length; index++) {
            const element = this.arrayIte[index]

            this.totalTable += element.qtyexp
          }
        } catch (error) {}
        this.viewTable = true
      })
  }

  onConfirmNewContainerItems (datosC: any) {
    console.log(datosC)

    try {
      var jj = {
        tipo: 1,
        id: Number(datosC.id_receive_container_itemsID),
        pto1: Number(datosC.pto1 || 0),
        plts1: Number(datosC.ptl1 || 0),
        qty1: Number(datosC.qty1 || 0),
        pto2: Number(datosC.pto2 || 0),
        plts2: Number(datosC.ptl2 || 0),
        qty2: Number(datosC.qty2 || 0),
        pto3: Number(datosC.pto3 || 0),
        plts3: Number(datosC.ptl3 || 0),
        qty3: Number(datosC.qty3 || 0),
        pto4: Number(datosC.pto4 || 0),
        plts4: Number(datosC.ptl4 || 0),
        qty4: Number(datosC.qty4 || 0),
        pto5: Number(datosC.pto5 || 0),
        plts5: Number(datosC.ptl5 || 0),
        qty5: Number(datosC.qty5 || 0),
        pto6: Number(datosC.pto6 || 0),
        plts6: Number(datosC.ptl6 || 0),
  
        qty6: Number(datosC.qty6 || 0),
        pto7: Number(datosC.pto7 || 0),
        plts7: Number(datosC.ptl7 || 0),
        qty7: Number(datosC.qty7 || 0),
        pto8: Number(datosC.pto8 || 0),
        plts8: Number(datosC.ptl8 || 0),
        qty8: Number(datosC.qty8 || 0),
        pto9: Number(datosC.pto9 || 0),
        plts9: Number(datosC.ptl9 || 0),
        qty9: Number(datosC.qty9 || 0),
        pto10: Number(datosC.pto10 || 0),
        plts10: Number(datosC.ptl10 || 0),
        qty10: Number(datosC.qty10 || 0),
        pto11: Number(datosC.pto11 || 0),
        plts11: Number(datosC.ptl11 || 0),
        qty11: Number(datosC.qty11 || 0),
        NumberInMaster: Number(datosC.NumberInMaster || 1),
        idPr: Number(datosC.idPr)
      }
      console.log(jj)

      this._httpClient
        .post<any>(
          `${environment.apiUrl}/Containers/ContainersItemsUpdateConfimacion`,
          jj,
          {
            headers: new HttpHeaders({
              'Access-Control-Allow-Origin': '*',
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Methods': '*',
              Authorization:
                'Bearer ' + this.authenticationService.currentUserValue.token
            })
          }
        )
        .subscribe((response: any) => {
          console.log(response)
        })
    } catch (error) {}
  }
  onCleaarte (da: string) {
    var text = ''
    try {
      var idc = da.split('-|')
      var cust = idc[0].replace('', '')
      text = cust
    } catch (error) {
      text = da
    }
    return text
  }
  @ViewChild('pdfTable3')
  pdfTable3!: ElementRef
  onExport () {
    let div = this.pdfTable3.nativeElement

    var img: any
    var filename
    var newImage: any
    var img2: any
    var filename2
    var newImage2: any
    var img3: any
    var filename3
    var newImage3: any
    var doc
    this.spinner.show()

    domtoimage
      .toPng(div, { bgcolor: '#fff' })

      .then(function (dataUrl) {
        img = new Image(865, 1400)
        img.src = dataUrl
        newImage = img.src

        img.onload = function () {
          var pdfWidth = img.width
          var pdfHeight = img.height

          // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image
          doc = new jsPDF('l', 'mm', 'a4', true)

          var width = doc.internal.pageSize.getWidth()
          var height = doc.internal.pageSize.getHeight()
          console.log(width, height)

          doc.addImage(newImage, 'JPEG', 10, 20, 270, 145)
          filename = 'Container' + '.pdf'
          doc.save(filename)
        }
      })
      .catch(function (error) {
        // Error Handling
      })
    this.spinner.hide()
  }

  onoculta () {
    if (this.ocultarT) {
      this.ocultarT = false
    } else {
      this.ocultarT = true
    }
  }

  onExportaExcelFormattt () {
    this._httpClient
      .get<any>(
        `${
          environment.apiUrl
        }/Containers/ContainerReceivingDataSelect?ContainerID=${Number(
          this.data.container.Id
        )}`,

        {
          headers: new HttpHeaders({
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Access-Control-Allow-Methods': '*',
            Authorization:
              'Bearer ' + this.authenticationService.currentUserValue.token
          })
        }
      )
      .subscribe((response: any) => {
        let mitad = Math.floor(response.length / 26)

        console.log(mitad, 'paartir array')
        if (response.length < 26) {
          mitad = 1
        }
        console.log(mitad, 'paartir array')
        var indexF = 0
        for (let index = 0; index < mitad; index++) {
          var arr = []
          var contador = indexF

          for (let index2 = indexF; index2 < response.length; index2++) {
            const element = response[index2]
            indexF++
            console.log(element, 'element')
            if (contador < 26) {
              arr.push(element)

              if (response.length == 1) {
                var j = {
                  title:
                    '' +
                    this.data.container.Id +
                    '-' +
                    this.data.container.ContainerNumber,
                  datosArray: arr
                }

                this.arrayDatosExport.push(j)
                arr = []
              }else  if (response.length <26) {
                var j = {
                  title:
                    '' +
                    this.data.container.Id +
                    '-' +
                    this.data.container.ContainerNumber,
                  datosArray: arr
                }

                this.arrayDatosExport.push(j)
                arr = []
              }
              contador++
            } else {
              var j = {
                title:
                  '' +
                  this.data.container.Id +
                  '-' +
                  this.data.container.ContainerNumber,
                datosArray: arr
              }

              this.arrayDatosExport.push(j)
              arr = []
              //contador = 0
              break
            }
          }
          console.log(this.arrayDatosExport, 'arr')
        }
        this.OnStateReportLinesExport()
      })
  }
  OnStateReportLinesExport () {
    const wb: XLSX.WorkBook = XLSX.utils.book_new()
    for (let index = 0; index < this.arrayDatosExport.length; index++) {
      const element = this.arrayDatosExport[index]
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(element.datosArray) //converts a DOM TABLE element to a worksheet
      //
      XLSX.utils.sheet_add_aoa(ws, [['CONTAINER#',element.title,], , [ '', '', '']], {origin: -1})

      XLSX.utils.book_append_sheet(wb, ws, element.title+'-'+String(index))
    }

    /* save to file */
    XLSX.writeFile(wb, '26items.xlsx')
  }
}
